export const eventLogConfig = {
  type: 'eventLog',
  label: 'Event Log',
  description: 'Display a live event log with timestamps and messages',

  defaults: {
    timeFormat: '24hour'
  },

  validate: (_config, title) => {
    return !!(title && title.trim());
  },

  formFields: []
};
